// Centralized data index for easy management and imports

// Import for internal use in utility functions
import type { Lesson } from './lessons/lessonData.ts';
import { unitsData } from './lessons/lessonData.ts';

// UI configuration exports
export {
    aksaraFilters, gameConfig, settingsFAQ,
    statusStyles,
    xpConfiguration, type FAQ, type FilterOption
} from './ui/uiConfig.ts';

// Existing data exports (re-exported for consistency)
export { achievementList } from './achievement/achievementData.ts';
export { baseChars, diacritics, groupedBaseChars, hamisaran, pangolat } from './aksara/aksaraData.ts';
export { coursesData } from './courses/courseData.ts';
export { unitsData, type Lesson, type Unit } from './lessons/lessonData.ts';

// Guide data exports
export { guideData, type GuideContent, type GuideData, type GuidePhrase, type GuidePhraseSentence } from './guide/guideData.ts';
export { wordBank, type WordBankItem } from './guide/wordBankData.ts';

// Guide utility functions
export {
    createFallbackGuideContent, getAvailableSectionsForUnit, getAvailableUnits, getGuideByUnitAndSection,
    getWordById,
    getWordsByIds
} from './guide/guideUtils.ts';

// Utility functions for working with lesson data
export const getLessonById = (id: string) => {
    for (const unit of unitsData) {
        const lesson = unit.lessons.find(lesson => lesson.id === id);
        if (lesson) return lesson;
    }
    return undefined;
};

export const getLessonsByType = (type: 'regular' | 'practice' | 'final') => {
    const lessons: Lesson[] = [];
    for (const unit of unitsData) {
        lessons.push(...unit.lessons.filter(lesson => lesson.type === type));
    }
    return lessons;
};

export const getUnitById = (id: string) => {
    return unitsData.find(unit => unit.id === id);
};

export const getLessonsByUnit = (unitId: string) => {
    const unit = getUnitById(unitId);
    return unit ? unit.lessons : [];
};

// Question type mapping for component routing
export const questionTypeComponents = {
    'vocab-intro': 'VocabIntroComponent',
    'word-translation': 'WordTranslationComponent',
    'compose-sentences': 'ComposeSentencesComponent',
    'matching-words': 'MatchingWordsComponent',
    'fill-in-the-blank': 'FillInBlankComponent'
};

// Sastra budaya exports
export { clothing } from './sastra-budaya/clothing.ts';
export { customs } from './sastra-budaya/customs.ts';
export { dances } from './sastra-budaya/dances.ts';
export { foods } from './sastra-budaya/foods.ts';
export { songs } from './sastra-budaya/songs.ts';
export { stories } from './sastra-budaya/stories.ts';

